module.exports = __webpack_public_path__ + "static/media/cerritos_college_logo.05b37de7.jpg";